import { mountVendorWindowEvent } from '../../mountVendorWindowEvent';

import { AgentioMethod } from './types';

import type { AgentioEvent, AgentioEventProperties } from './types';

export interface TrackAgentioEventArgs {
  name: AgentioEvent;
  properties?: Record<string, unknown>;
}

function _mountAgentioEvent(w: Window, { name }: TrackAgentioEventArgs) {
  const properties: AgentioEventProperties = {
    detail: {
      conversionType: name,
    },
  };
  const event = new CustomEvent(AgentioMethod.AgentioConversion, properties);
  w.document.dispatchEvent(event);
}

export const mountAgentioEvent = mountVendorWindowEvent(
  'Agentio',
  _mountAgentioEvent
);
